import { useCallback, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"

import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import { useDropzone } from "react-dropzone"


import { useRequestProcessor } from "../../api/requestProcessor"
import { uploadImage } from "../../api/upload-files"
import { getSingleBlog, updateSingleBlogs } from "../../api/blogs"
import { domainName } from "../../constants/site"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import makeAnimated from 'react-select/animated';
import Select from "react-select"
import { getAllCategoriesWithType } from "../../api/categories"
import Loading from "../../components/loading/loading"


const EditBlogs = () => {

    const [name, setName] = useState("")
    const [category, setCategory] = useState([])
    const [thumb, setThumb] = useState()

    const [blogPicture, setBlogPicture] = useState()

    const [description, setDescription] = useState("")
    const [convertedContent, setConvertedContent] = useState(null);


    const navigate = useNavigate()
    const { blog_id } = useParams()


    const { Query, Mutate } = useRequestProcessor()


    function onDescriptionHandler(event) {
        setDescription(event.target.value)
    }

    const { data, isLoading, isError } = Query(
        ['getSingleBlog', blog_id],
        () => getSingleBlog(blog_id),
    );

    const { data: categoryData, isLoading: discountLoading, refetch } = Query(
        ['getAllCategoryByType', "blogs"],
        () => getAllCategoriesWithType("blogs")
    );

    useEffect(() => {
        setName(data?.data?.title)
        setDescription(data?.data?.description)
        setConvertedContent(data?.data?.body)
        setCategory(data?.data?.categories.map(el => ({ label: el.title, value: el.id })))
        let i;
        for (i = 0; i <= data?.data?.files.length; i++) {
            if (data?.data?.files[i]?.type === "cover") {
                setThumb(data?.data?.files[i].file?.thumb)
            }
            if (data?.data?.files[i]?.type === "image") {
                setBlogPicture(data?.data?.files[i].file?.thumb)
            }
        }
        console.log(data?.data?.categories.map(el => ({ label: el.title, value: el.id })));
    }, [data])

    //  react query req

    const { mutate: storeBlogData } = Mutate(
        "updateBlog",
        updateSingleBlogs,
        {
            onSuccess: (data) => {
                toast.success(data.message + " تا چند ثانیه دیگر به صفحه اصلی منتقل میشوید")
                setTimeout(() => { navigate("/admin/blogs") }, 3000)
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );
    const { mutate } = Mutate(
        "uploadImage",
        uploadImage,
        {
            onSuccess: (data) => {
                successfulHandler(data) //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );
    const { mutate: blogImageMutate } = Mutate(
        "uploadImage",
        uploadImage,
        {
            onSuccess: (data) => {
                successfulBlogImageHandler(data) //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );



    const onDrop = useCallback(acceptedFiles => {
        let formData = new FormData();
        formData.append("images", acceptedFiles[0])
        blogImageMutate(formData)
    }, [])


    const onDropThumb = useCallback(acceptedFiles => {
        let formData = new FormData();
        formData.append("images", acceptedFiles[0])
        mutate(formData)
    }, [])




    // DROPZONE CONFIG

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop, accept: {
            'image/jpeg': [],
            'image/jpg': [],
            'image/png': [],
        }
    })
    const { getRootProps: getThumbRootprops, getInputProps: getThumbInputProps, isDragActive: isThumbDragActive } = useDropzone({
        onDrop: onDropThumb, accept: {
            'image/jpeg': [],
            'image/jpg': [],
            'image/png': [],
        }
    })




    function successfulHandler(res) {
        toast.success("فایل با موفقیت آپلود شد.")
        setThumb(res.images.thumb);
    }
    function successfulBlogImageHandler(res) {
        toast.success("فایل با موفقیت آپلود شد.")
        setBlogPicture(res.images.thumb);
    }

    async function onSubmitHandler(e) {
        e.preventDefault();
        let data = {
            id: blog_id, data: {
                title: name,
                description: description,
                category_id: category?.map(el => el.value),
                body: convertedContent,
                cover_image: {
                    thumb: thumb
                },
                blog_images: {
                    thumb: blogPicture
                },

            }
        }
        storeBlogData(data);
    }

    const animatedComponents = makeAnimated();
    function handleOnChange(data) {
        setCategory(data)
    }



if(isLoading) return <Loading />


return (
    <Layout >
        <MainPageLayout backButton sectionTitle={"مشخصات بلاگ " + data?.data?.title + " :"} title={"تصحیح بلاگ"} >
            <form onSubmit={onSubmitHandler}>
                <div className="flex">
                    <div className='flex flex-col mb-4 w-full'>
                        <div className='flex flex-col mb-3'>
                            <p className='pr-3 pb-1'>نام بلاگ :</p>
                            <input type="text" value={name} onChange={(e) => setName(e.target.value)} className=' form-input !w-full' placeholder='نام بلاگ' />
                        </div>
                        <div className='flex flex-col my-3'>
                            <p className='pr-3 pb-1'>توضیح بلاگ:</p>
                            <div className='flex form-input !w-full items-center '>
                                <input value={description} onChange={onDescriptionHandler} type="text" className='form-input !w-full' placeholder='توضیح مختصر درباره بلاگ ' />
                                <div className={`flex basis-1/4 justify-center border ${description?.length > 180 ? "!bg-red-500 text-white" : "text-green-500"} border-black rounded-xl py-2 mr-2 bg-white`}>180 / {description?.length} </div>
                            </div>
                        </div>
                        <div className='flex flex-col my-3'>
                            <p className='pr-3 pb-1'>انتخاب دسته بندی :</p>
                            <Select components={animatedComponents} placeholder="انتخاب کنید..."
                                onChange={handleOnChange} closeMenuOnSelect={false}
                                isMulti options={categoryData?.data?.map(el => ({ label: el.title, value: el.id }))}
                                value={category }
                                
                            />
                        </div>
                        {/* <div className='flex flex-col my-3'>
                                <p className='pr-3 pb-1'>انتخاب دسته بندی :</p>
                                <select value={category} onChange={e => setCategory(e.target.value)} className=" w-1/2 mr-4 wsm:!w-full border border-gray-500 py-[10px] px-[20px] rounded-[10px] focus:border-[#1976d2bf]" >
                                    <option selected disabled hidden>انتخاب نوع دسته بندی</option>
                                    <option value={"blog"} >بلاگ</option>
                                    <option value={"workshop"} >ورک شاپ</option>
                                </select>
                            </div> */}
                    </div>
                    <div className="w-full flex flex-col mr-4">

                        <div className="flex flex-col mb-4">
                            <p className='pr-3 pb-1'>انتخاب عکس بنر :</p>

                            <form id='recommendationDiv' className="flex justify-center h-full items-center border border-dashed py-5 bg-gray-100 cursor-pointer rounded-2xl hover:border-sky-600" {...getThumbRootprops()}>
                                <input
                                    {...getThumbInputProps()} />
                                {
                                    <p> فایل را انتخاب یا به اینجا بکشید</p>
                                }
                            </form>
                            <div className="flex justify-center my-2">
                                <img src={domainName + thumb} className="w-[150px]" alt="" />
                            </div>
                        </div>
                        <div className="flex flex-col mb-4">
                            <p className='pr-3 pb-1'>انتخاب عکس بلاگ :</p>

                            <form id='recommendationDiv' className="flex justify-center h-full items-center border border-dashed py-5 bg-gray-100 cursor-pointer rounded-2xl hover:border-sky-600" {...getRootProps()}>
                                <input
                                    {...getInputProps()} />
                                {
                                    <p> فایل را انتخاب یا به اینجا بکشید</p>
                                }
                            </form>
                            <div className="flex justify-center my-2">
                                <img src={domainName + blogPicture} className="w-[150px]" alt="" />
                            </div>
                        </div>

                    </div>
                </div>

                <div>
                    <CKEditor
                        editor={ClassicEditor}
                        data={convertedContent ?? ""}
                        config={{
                            language: {
                                ui: "en",
                                content: "ar"
                            }
                        }}
                        onReady={editor => {
                            // You can store the "editor" and use when it is needed.
                            console.log('Editor is ready to use!', editor);
                        }}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            setConvertedContent(data);
                        }}

                    />
                </div>
                <p className='pr-3 text-sm'>متاتگ های وبسایت بر اساس کلمات نوشته شما ساخته میشود</p>

                <div id='form-add-button--container'>
                    <button type="submit" id='form-add-button'>ثبت</button>
                </div>
            </form>
        </MainPageLayout>
    </Layout>
)
}

export default EditBlogs